interface SvgIconProps {
    className?: string;
    defaultFill: string;
    children?: React.ReactNode;
    width?: string;
    height?: string;
    viewBox?: string;
}

export default function SvgIcon({className, defaultFill, width, height, viewBox, children}: SvgIconProps) {
    if (!className?.includes('fill-')) {
        className = ' ' + defaultFill;
    }

    if (!width) {
    }

    if (!height) {
    }

    if (!viewBox) {
        viewBox = "0 -960 960 960"
    }

    return <>
        {width && height && <>
            <svg
                className={className}
                xmlns="http://www.w3.org/2000/svg"
                viewBox={viewBox}
                width={width}
                height={height}
            >
                {children}
            </svg>
        </>}
        {(!width || !height) && <>
            <svg
                className={className}
                xmlns="http://www.w3.org/2000/svg"
                viewBox={viewBox}
            >
                {children}
            </svg>
        </>}
    </>;
}